import Vue from "vue/dist/vue.esm.js";

// 全局配置
import GLOBAL_CONFIG from "./config";

// 全局混入
Vue.mixin({
    data() {
        return {
            GLOBAL_CONFIG
        };
    },
    methods: {
        // 锚点固定的容器
        getModuleContainer() {
            return document.querySelector(".content-container");
        }
    }
});
